import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: 'fit-content',
    maxHeight: 'calc(100svh - 21rem)'
  },

  noData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60px',
    color: theme.palette.textLightFaded,
    fontSize: theme.size.lg
  },

  dataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  name: {
    flex: 1
  },

  dot: {
    width: 'auto',
    minHeight: 'unset'
  }
}))

export default useStyles
